import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {ref, onActivated, reactive, onMounted} from 'vue';

import Trabslator from "./Trabslator.vue"
import Efficiency from "./Efficiency.vue"
import store from "@/store/index"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('first')
const showModel=ref(false)
let {
    // 译员列表
    'GET/efficiency/translator/users':translatorListApi,
    // 团队列表
    'GET/efficiency/translator/orgList':efficiencyOrgListApi
}=Api
const translatorList=ref([])
const orgList=ref([])
const getTranslatorLists=()=>{
  translatorListApi().then((res:any)=>{
      translatorList.value=res
  })
}
const getOrgList=()=>{
  efficiencyOrgListApi().then((res:any)=>{
    orgList.value=res
  })
}
onMounted(()=>{    
    let {efficiency_translate}=store.getters.privileges
    getTranslatorLists()
    getOrgList()
    showModel.value=efficiency_translate?efficiency_translate.includes('Manage')?true:false:false
    
})



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "译员效率值",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(Trabslator, {
              translatorList: translatorList.value,
              orgList: orgList.value
            }, null, 8, ["translatorList", "orgList"])
          ]),
          _: 1
        }),
        (showModel.value)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "效率值管理",
              name: "second",
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(Efficiency, {
                  translatorList: translatorList.value,
                  orgList: orgList.value
                }, null, 8, ["translatorList", "orgList"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})